import {h, Fragment} from "preact"
import { useAppState, useResponse, AutocompleteElement, Keywords } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks";
import { closeSearchOverlay } from "../helpers"

import DropdownProduct from "./DropdownProduct"

export default function Autocomplete() {
    const { products, keywords } = useResponse();
    if (!products?.hits?.length && !keywords?.hits?.length) return
    const { query } = useAppState();
    const keywordsRef = useRef(null);

    const [ maxHeight, setMaxHeight ] = useState(window.innerHeight + 'px');
    useEffect(() => {
        const searchHeader = document.querySelector('.search-modal__content-bottom');
        if(!searchHeader) return;
        setMaxHeight((window.innerHeight - searchHeader.offsetHeight) + 'px');
    }, [])
    
    useEffect(() => {
        if(!keywordsRef.current) return;
        const handleClick = (event) => {
            if(
                keywordsRef.current.contains(event.target) &&
                event.target.closest('.ns-autocomplete-element')
            ) {
                closeSearchOverlay();
            }
        }
        keywordsRef.current.addEventListener('click', handleClick);
        return () => keywordsRef.current.removeEventListener('click', handleClick);
    }, [])

    // useEffect(() => {
    //     if(typeof window.Nosto?.migrateToShopifyMarket !== 'function') return;
    //     window.Nosto.migrateToShopifyMarket({
    //         productSectionElement: '.ns-autocomplete__product',
    //         productUrlElement: '.ns-autocomplete__product-wrapper',
    //         productHandleAttribute: 'data-handle',
    //         priceElement: '.ns-autocomplete__product-price-container > .ns-autocomplete__product-final-price',
    //         listPriceElement: '.ns-autocomplete__product-price-container > .ns-autocomplete__product-regular-price',
    //     })
    // }, [ products.hits ])

    return (
        <div
            className="ns-autocomplete block absolute m-0"
            data-nosto-element="autocomplete"
            style={`max-height: ${maxHeight};`}
        >
            <div className="ns-autocomplete-inner w-full flex flex-col gap-8">

                <div className="ns-autocomplete-group ns-keywords-group">
                    <div>
                        {keywords?.hits?.length > 0 && (
                            <>
                            <h3 id="ns-autocomplete-keywords" className="ns-autocomplete__header text-left caps-md mt-0 mb-4 p-0 !text-grey-5">
                                Suggestions
                            </h3>
                            <ul className="text-left list-unstyled p-0 m-0" aria-labelledby="ns-autocomplete-keywords" role="group" ref={keywordsRef}>
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </ul>
                            </>
                        )}
                    </div>
                </div>

                <div className="ns-autocomplete-group ns-products-group">
                    <div>
                        {products?.hits?.length > 0 && (
                            <>
                            <h3 id="ns-autocomplete-products" className="ns-autocomplete__header text-left caps-md mt-0 mb-4 p-0 !text-grey-5">
                                Products
                            </h3>
                            <ul className="ns-autocomplete__products_list text-left flex list-unstyled p-0 m-0" aria-labelledby="ns-autocomplete-products" role="group">
                                {products.hits.map((hit, index) => (
                                    <DropdownProduct
                                        key={hit.productId || index}
                                        product={hit}
                                    />
                                ))}
                            </ul>
                            </>
                        )}
                    </div>
                </div>
                
            </div>
            {query?.query && (
                <div className="ns-autocomplete__footer">
                    <button className="ns-autocomplete__submit cursor-pointer w-full text-left text-black text-sm flex flex-nowrap items-center justify-between" type="submit" onClick={closeSearchOverlay}>
                        <span className="ns-autocomplete__submit-text text-black w-full">
                            Search for "{query.query}"
                        </span>
                        <svg className="ns-autocomplete__submit-icon icon block" viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
                        </svg>
                    </button>
                </div>
            )}
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <p className="text-black text-sm m-0" data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </p>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <li className="ns-autocomplete__keyword-item" role="option" aria-selected="false">
            <AutocompleteElement 
                hit={hit} 
                filter={filter} 
                class="w-full flex flex-nowrap cursor-pointer"
            >
                {keywordComponent}
            </AutocompleteElement>
        </li>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <>
        {category?.value ? (
            <>
            {children}{" "}
            <span className="ns-keyword-in-category">
                in <span>{category.value}</span>
            </span>
            </>
        ) : (
            children
        )}
        </>
    )
}
